import { IUser, UserType } from "muminsmart-utils";
import { routes } from "@/lib/constants";

export function getHomeRouteForUser(
  user?: Pick<IUser, "type" | "sellers">,
): string {
  if (user?.type === UserType.Seller) {
    const sellerId = user.sellers?.[0]?.id;
    if (sellerId) {
      return routes.seller.id(sellerId);
    }
  }

  return routes.home;
}
